
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/modernization",
      function () {
        return require("private-next-pages/cases/modernization/index.tsx");
      }
    ]);
  